import r from "./contact-channels78.js";
import i from "./contact-channels79.js";
var a = {
  ignore_whitespace: !1
};
function f(e, t) {
  return r(e), t = i(t, a), (t.ignore_whitespace ? e.trim().length : e.length) === 0;
}
export {
  f as default
};
//# sourceMappingURL=contact-channels62.js.map
